var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSnackbar',{attrs:{"right":"","timeout":_vm.alertTxt.timeout,"top":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('VAlert',{attrs:{"type":_vm.alertTxt.type},domProps:{"innerHTML":_vm._s(_vm.alertTxt.txt)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }